/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EncounterDetailModel } from '../../models/encounter-detail-model';

export interface EncounterCompleteEncounterPost$Params {
      body?: any
}

export function encounterCompleteEncounterPost(http: HttpClient, rootUrl: string, params?: EncounterCompleteEncounterPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<EncounterDetailModel>> {
  const rb = new RequestBuilder(rootUrl, encounterCompleteEncounterPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<EncounterDetailModel>;
    })
  );
}

encounterCompleteEncounterPost.PATH = '/Encounter/CompleteEncounter';
